import React, { useState, useEffect } from 'react';
import { isProduction } from './utils';
import './Principal.scss';
import './Dolar.scss';

const Dolar = ({ selectedCasas, onToggleCasa, editing }) => {
    const [dolarData, setDolarData] = useState(null);

    useEffect(() => {
        const fetchDolar = async () => {
            try {
                const response = await fetch(`${isProduction() ? window.location.origin : 'http://localhost:8080'}/api/dolares`);
                if (!response.ok) throw new Error('Error al cargar datos del dólar');
                const data = await response.json();
                setDolarData(data);
            } catch (err) {
                console.error('Error fetching dolar:', err);
            }
        };

        fetchDolar();
        const interval = setInterval(fetchDolar, 15 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    if (!dolarData) return null;

    return (
        <>
            {editing && (
                <div style={{ maxWidth: '1400px', margin: '0 auto 24px' }}>
                    <div className="casa-selector">
                        <div className="casa-selector-title">Selecciona las casas de cambio a mostrar:</div>
                        <div className="casa-selector-checkboxes">
                            {dolarData.dolares.map(dolar => (
                                <button
                                    key={dolar.casa}
                                    onClick={() => onToggleCasa(dolar.casa)}
                                    className={`casa-selector-checkbox ${selectedCasas.includes(dolar.casa) ? 'selected' : ''}`}
                                >
                                    {dolar.casa}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {!editing && selectedCasas.length > 0 && (
                <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                    <div className="dolar-section">
                        <div className="dolar-cards">
                            {dolarData.dolares
                                .filter(dolar => selectedCasas.includes(dolar.casa))
                                .map(dolar => (
                                    <div key={dolar.casa} className="dolar-card">
                                        <div className="dolar-card-title">{dolar.casa}</div>
                                        <div className="dolar-values">
                                            {dolar.compra && (
                                                <div className="dolar-value">
                                                    <div className="dolar-label">Compra</div>
                                                    <div className="dolar-amount green">
                                                        ${typeof dolar.compra === 'number' ? dolar.compra.toLocaleString('es-AR') : dolar.compra}
                                                    </div>
                                                </div>
                                            )}
                                            {dolar.venta && (
                                                <div className="dolar-value">
                                                    <div className="dolar-label">Venta</div>
                                                    <div className="dolar-amount red">
                                                        ${typeof dolar.venta === 'number' ? dolar.venta.toLocaleString('es-AR') : dolar.venta}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Dolar;